// timestamps.js
// The one way an audit timestamp is written for the user: "01 Aug 26, 20:00".
// Every customer is UK-based, so the form is fixed rather than taken from the
// browser (which would switch between US and UK orders and 12/24-hour clocks
// from machine to machine). Accepts a Firestore Timestamp, a Date, an ISO
// string or epoch milliseconds; anything unreadable formats as ''.
import dayjs from 'dayjs';

export const TIMESTAMP_FORMAT = 'DD MMM YY, HH:mm';
export const DATE_FORMAT = 'DD MMM YY';

// Milliseconds for a Firestore Timestamp, a Date, an ISO string, or nothing (0).
export const toMillis = (value) => {
  if (!value) return 0;
  if (value.toDate) return value.toDate().getTime();
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? 0 : parsed.getTime();
};

export const toDateValue = (value) => {
  if (value == null || value === '') return null;
  if (typeof value.toDate === 'function') {
    try { return value.toDate(); } catch (e) { return null; }
  }
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatTimestamp = (value) => {
  const date = toDateValue(value);
  return date ? dayjs(date).format(TIMESTAMP_FORMAT) : '';
};

export const formatDateOnly = (value) => {
  const date = toDateValue(value);
  return date ? dayjs(date).format(DATE_FORMAT) : '';
};
